// These will be deprecated at a future date
export const NEW = 1;
export const ACTIVE = 2;
export const SOFT_QUOTE = 3;
export const LOAN_CLOSED = 4;
export const ARCHIVED = 5;
// export const SOLD = 6;

/*
 * New deal statuses
 * From table "deal_statuses"
 */
export const PIPELINE = "6a5f04ac-4720-11e9-bd01-0242ac140002";
export const DEAD = "6a5f04dc-4720-11e9-bd01-0242ac140002";
export const CLOSED = "6a5f04ec-4720-11e9-bd01-0242ac140002";
export const REFINANCE = "6a5f04f9-4720-11e9-bd01-0242ac140002";
export const SOLD = "6a5f0507-4720-11e9-bd01-0242ac140002";
export const MODIFYING = "5c00eb29-b4cd-471c-b820-47773d09fa94";
export const ADDING_SUPPLEMENTAL = "f9bf13d0-e918-4fe8-9227-d0304c9f2a8b";

export default {
  PIPELINE,
  DEAD,
  CLOSED,
  REFINANCE,
  SOLD,
  MODIFYING,
  ADDING_SUPPLEMENTAL
};
